module.exports = __webpack_public_path__ + "img/web.472c7710.png";